"use client";

import { useQuery } from "@tanstack/react-query";
import { PulsarService } from "@/services/pulsar.service";
import { useConnection } from "@/contexts/connection-context";
import { useAuthContext } from "@/contexts/auth-context";

export const useGetReferrals = (
  campaignId: string,
  groupId: string | undefined,
  address: string,
  page: number,
  limit: number
) => {
  const { isAuthenticated } = useConnection();
  const { accessToken } = useAuthContext();

  return useQuery({
    queryKey: ['referrals', campaignId, groupId, address, page, limit],
    queryFn: () =>
      PulsarService.getReferrals(
        campaignId,
        groupId,
        address,
        page,
        limit
      ),
    enabled: isAuthenticated && !!address && !!campaignId && !!accessToken,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
